/**
 * @Description
 */

import { FC, useMemo, } from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import IconFont from '@/common/components/IconFont';
import Scores from '@/common/components/business/StoreDetail/components/DynamicDetail/components/AreaOverview/components/Scores';
import { isNotEmpty } from '@lhb/func';

const Evaluation: FC<{
  detail,
}> = ({
  detail,
}) => {
  const cardView = useMemo(() => {
    return detail?.scores || [];
  }, [detail]);

  // 在这里编写组件的逻辑和渲染
  return (
    <div className={styles.evaluationCon}>
      <div className={styles.flexHeadCon}>
        <div style={{ flex: 1 }}>
          <div className={styles.titleRow}>
            <div className='c-222 fs-14 bold'>{detail?.areaName || '-'}</div>
            {detail?.areaName ? <IconFont iconHref='pc-common-icon-ic_arrow_right' className='fs-14 c-222'/> : <></>}
          </div>
          <div className={styles.labelRow}>
            <div className={cs(styles.label, styles.notRecommandLabel, 'mr-4')}>商圈外</div>
            {/* {detail?.firstLevelName && <div className={styles.label}>{detail?.firstLevelName}</div>} */}
          </div>
        </div>
        <div className='ct mr-16 mb-6'>
          <div className='fs-20 c-569 ff-impact'>{isNotEmpty(detail?.marketScore) ? detail?.marketScore : '-'}</div>
          <div className='fs-12 c-222'>综合评分</div>
        </div>
      </div>
      <Scores scores={cardView}/>
    </div>
  );
};

export default Evaluation;
